import { AnnotationStatus } from "@faro-lotv/ielement-types";
import { getMarkupStatusValue } from "@pages/project-details/project-markups/status/markup-status-utils";
import { DUE_SOON_FILTER_ID, isOverdueTrackedStatus, OVERDUE_FILTER_ID } from "@pages/project-details/project-overview/markups-summary/markups-summary-utils";

/** How urgent the due date of a markup is */

/**
 * Returns how urgent the due date of the markup is, as the overdue and due soon KPIs count it.
 * The due date filters are passed so they are created once for all the markups.
 */
export function getMarkupDueDateUrgency(markup, dueDateFilters) {
  if (!isOverdueTrackedStatus(getMarkupStatusValue(markup.status?.value))) {
    return "none";
  }
  if (dueDateFilters[OVERDUE_FILTER_ID].hasEntityPassedFilter(markup)) {
    return "overdue";
  }
  return dueDateFilters[DUE_SOON_FILTER_ID].hasEntityPassedFilter(markup) ? "dueSoon" : "none";
}

/** Statuses of the columns of the board, in the order of the workflow */
export const MARKUPS_BOARD_STATUSES = [AnnotationStatus.Unclassified, AnnotationStatus.Open, AnnotationStatus.InProgress, AnnotationStatus.ToReview, AnnotationStatus.Resolved];

/**
 * Returns the markups of each column of the board, in the order they are provided.
 * A pending status, of a markup being moved, wins over the stored one.
 */
export function getMarkupsBoardColumns(markups, pendingStatuses = {}) {
  const columns = {
    [AnnotationStatus.Unclassified]: [],
    [AnnotationStatus.Open]: [],
    [AnnotationStatus.InProgress]: [],
    [AnnotationStatus.ToReview]: [],
    [AnnotationStatus.Resolved]: []
  };
  for (const markup of markups) {
    const status = pendingStatuses[markup.id] ?? getMarkupStatusValue(markup.status?.value);
    columns[status].push(markup);
  }
  return columns;
}